import { Menu, X } from "lucide-react";

/**
 * Mobile-only hamburger button. Tap target meets 44×44 accessibility minimum.
 */
export default function MobileMenuButton({ open, onToggle }) {
  return (
    <button
      type="button"
      data-testid="mobile-nav-toggle"
      aria-label={open ? "Close navigation" : "Open navigation"}
      aria-expanded={open}
      onClick={onToggle}
      className="lg:hidden inline-flex items-center justify-center rounded-md p-2.5 -mr-1 text-foreground/80 hover:text-primary hover:bg-foreground/5 transition-colors min-h-[44px] min-w-[44px]"
    >
      {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
    </button>
  );
}
